import { get } from "./get"
import { update } from "./update"

export const activities = {
  get,
  update,
}
